import * as React from 'react';
import { useController } from 'react-hook-form';
import {
  ComputeExpressionMinimalBaseInput,
  IComputeExpressionMinimalBaseInputProps,
} from './ComputeExpressionMinimalBaseInput';

export interface IComputeExpressionMinimalInputProps
  extends Omit<
    IComputeExpressionMinimalBaseInputProps,
    'value' | 'onChange' | 'onBlur'
  > {
  name: string;
}

/**
 * Input per la gestione dell'espressione di calcolo
 * tramite l'editor Tiptap
 */
export function ComputeExpressionMinimalInput(
  props: IComputeExpressionMinimalInputProps,
) {
  const { name, ...otherProps } = props;
  const {
    field: { value, onChange, onBlur },
  } = useController({ name: props.name });

  return (
    <ComputeExpressionMinimalBaseInput
      {...otherProps}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
}
